import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.055 9.524a.997.997 0 0 0-1.192.761A6.035 6.035 0 0 1 9 15c-3.308 0-6-2.692-6-6 0-3.309 2.692-6 6-6 1.515 0 2.922.561 4.005 1.54l-.273-.056a.991.991 0 0 0-1.177.784 1 1 0 0 0 .784 1.177l3.536.707a1.011 1.011 0 0 0 .904-.274c.236-.236.338-.575.273-.903l-.707-3.536a.993.993 0 0 0-1.177-.784 1 1 0 0 0-.784 1.177l.063.311A7.934 7.934 0 0 0 9 1C4.589 1 1 4.588 1 9c0 4.411 3.589 8 8 8 3.514 0 6.667-2.35 7.668-5.715.056-.187.106-.377.148-.569a1 1 0 0 0-.761-1.192Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
